import * as React from "react";
import styled, { css } from "../../../styled/index";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { ModalContent, ModalTitle } from "./content";

interface Props {
  title: React.ReactNode;
  children?: React.ReactNode;
  level?: 1 | 2;
  paddingtb?: number;
  paddinglr?: number;
  cPaddingtb?: number;
  cPaddinglr?: number;
  onDrop?: (dropped: boolean) => void;
}

const Wrapper = styled("div")`
  .content {
    border-bottom: 1px solid ${(props) => props.theme.box.border};
  }
`;

const Icon = styled("div")`
  font-size: 16px;
`;

export class ModalDropContent extends React.Component<Props, { active: boolean }> {

  constructor(props: Props) {
    super(props);
    this.state = { active: false };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    const active = !this.state.active;
    this.setState({ active });
    if (this.props.onDrop) {
      this.props.onDrop(active);
    }
  }

  render() {
    const { active } = this.state;
    const props = this.props;
    return (
      <Wrapper>

        <ModalTitle
          className="cursor"
          level={props.level}
          onClick={this.toggle}
          paddinglr={props.paddinglr}
          paddingtb={props.paddingtb}>
          {props.title}
          <Icon>
            {active ? <FaChevronUp/> : <FaChevronDown/>}
          </Icon>
        </ModalTitle>

        {active && (
          <ModalContent
            className="content"
            paddinglr={props.cPaddinglr}
            paddingtb={props.cPaddingtb}>
            {props.children}
          </ModalContent>
        )}

      </Wrapper>
    );
  }

}
